/*
* Creates a clickable google maps embedded iframe for a given address
*/

import * as QueryString from 'query-string';
import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Iframe from 'react-iframe';

import * as AppComp from './app-component-base';
import * as ReduxQueries from '../queries';
import AppConfiguration from '../config/configuration';
import { Formatters } from './formatters';

export interface IGoogleMapEmbedProps extends AppComp.IAppComponentProps {
    enabled?: boolean;
    locationDocument?: any;
    mapHeight?: number;
    mapWidth?: number;
    mapZoom?: number;
    mapIe?: string;
    mapIwLock?: string;
    mapOutput?: string;
}

export class GoogleMapEmbed extends AppComp.AppComponent<IGoogleMapEmbedProps, any> {
    public static defaultProps = {
        enabled: false,
        locationDocument: {},
        mapHeight: 320,
        mapWidth: 400,
        mapZoom: 12,
        mapIe: 'UTF8',
        mapIwLock: 'B',
        mapOutput: 'embed',
    };

    public constructor(props: IGoogleMapEmbedProps) {
        super(props, 'app.google-map-link.');
    }

    public composeMapUrl(address: string = '', width: number = 400, height: number = 320, zoom: number = 14, ie: string = 'UTF8', iwLock: string = 'B', output: string = 'embed') {
        let result = '';
        if (!address) { return result; }

        const googleMapsConfig = AppConfiguration.getGoogleMapsConfiguration();
        result = Formatters.getStr(googleMapsConfig, 'googleMapsEmbedUrl');

        result += `?${QueryString.stringify({
            q: address,
            key: Formatters.getStr(googleMapsConfig, 'googleMapsApiKey'),
            width: width,
            height: height,
            hl: 'en',
            ie: ie,
            z: zoom,
            iwloc: iwLock,
            output: output,
        })}`;

        return result;
    }

    public render() {
        const { locationDocument, enabled, mapWidth, mapHeight, mapZoom, mapIe, mapIwLock, mapOutput, ...rest } = this.props;

        if (locationDocument && enabled) {
            const address = Formatters.composeLocationFullAddress(locationDocument);

            if (address) {
                const iframeSrcUrl = this.composeMapUrl(address, mapWidth, mapHeight, mapZoom, mapIe, mapIwLock, mapOutput);

                return (
                    <Iframe
                        url={iframeSrcUrl}
                        width={`${mapWidth}px`}
                        height={`${mapHeight}px`}
                        id="iframeId"
                        className="iframeClassName"
                        position="relative"
                        frameBorder={0}
                    />
                );
            }
        }

        return null;
    }
}

const mapStateToProps = (state: AppComp.IAppComponentState, props): IGoogleMapEmbedProps => {
    const mapped = ReduxQueries.MapQueryStateToPropsRoot(state, props, null);

    return mapped;
};

const t = connect(mapStateToProps, {})(GoogleMapEmbed);
export default withRouter<IGoogleMapEmbedProps>(t);



// WEBPACK FOOTER //
// ./src/common/googlemapembed.tsx